import axios from 'axios'

export default class Reset_datos_user {
    
    public async Reset_contrasenia_user(mail:string): Promise<string[] | undefined> {
        try {
            const api = process.env.VUE_APP_USER + 'ForgotPassPublicUser/'+ mail; 
            const config = {
                headers:{
                Content: 'application/json',
                responseType: "json"
                }
            };        
            const result = await  axios.get(api, config);
            // console.log(result);
            return result.data; 

        } catch (error) {
            console.error('Error al enviar el correo : ', error);
            throw error;
        }
    }

    public async confirmacion_Reset_contrasenia(user_id:string,code_:string,password_:string): Promise<string[] | undefined> {
        try {
            const api = process.env.VUE_APP_USER    + 'ChanguePassPublicUser/'; 
            const config = {     
                params:{
                    userId:user_id,
                    code:code_,
                    password:password_
                } ,         
                headers:{
                Content: 'application/json',
                responseType: "json"
                }
            };        
            const result = await  axios.get(api,  config);
            // console.log(result);
            return result.data; 

        } catch (error) {
            console.error('Error al cambiar la contraseña : ', error);
            throw error;
        }
    }

}
